<div class="table-page fraud-cases" dir="rtl">
  <div class="fraud-cases-toolbar" [formGroup]="dateForm">
    <h2>پرونده‌های مشکوک</h2>
    <div class="actions">
      <label for="fraud-cases-date">تاریخ تحلیل</label>
      <ng-persian-datepicker class="fraud-datepicker" [uiTheme]="'gray'" [timeEnable]="false"
        [dateInitValue]="false" [dateFormat]="'jYYYY/jMM/jDD'" [dateGregorianFormat]="'YYYY/MM/DD'"
        [uiHideAfterSelectDate]="true" [uiHideOnOutsideClick]="true">
        <input id="fraud-cases-date" class="control" type="text" dir="ltr" readonly formControlName="date" />
      </ng-persian-datepicker>
      <button class="btn btn-primary" type="button" [disabled]="loading" (click)="loadCases(true)">
        <i class="fa fa-refresh" aria-hidden="true"></i> بروزرسانی
      </button>
    </div>
  </div>

  <section class="card">
    <div class="fraud-cases-heading">
      <h2>فهرست پرونده‌های مشکوک</h2>
      <label class="fraud-status-filter">
        <span>وضعیت پرونده</span>
        <select id="fraud-review-status" class="control" [ngModel]="reviewStatus" (ngModelChange)="changeStatus($event)">
          <option [ngValue]="null">همه وضعیت‌ها</option>
          <option [ngValue]="0">در انتظار بررسی</option>
          <option [ngValue]="1">تأیید شده</option>
          <option [ngValue]="2">رد شده</option>
        </select>
      </label>
    </div>

    <div class="body">
      <div *ngIf="loading" class="loader show">
        <div class="spinner"></div>
        <span>در حال دریافت پرونده‌ها...</span>
      </div>
      <div *ngIf="!loading && error" class="state show error">
        <i class="fa fa-exclamation-triangle ico-big" aria-hidden="true"></i>
        <p>{{ error }}</p>
        <button class="btn btn-ghost" type="button" (click)="loadCases()">تلاش دوباره</button>
      </div>
      <div *ngIf="!loading && !error && !cases.length" class="state show">
        <i class="fa fa-folder-open-o ico-big" aria-hidden="true"></i>
        <h3>برای این تاریخ و وضعیت، پرونده‌ای یافت نشد.</h3>
        <p>تاریخ یا وضعیت بررسی را تغییر دهید و دوباره جستجو کنید.</p>
        <button *ngIf="reviewStatus !== null" class="btn btn-ghost" type="button" (click)="changeStatus(null)">نمایش همه وضعیت‌ها</button>
      </div>
      <div *ngIf="!loading && !error && cases.length" class="table-scroll">
        <table>
          <thead>
            <tr>
              <th>پرونده</th>
              <th>خودروی اول</th>
              <th>خودروی دوم</th>
              <th>بازه حرکت</th>
              <th>امتیاز</th>
              <th>حرکت مشترک</th>
              <th>وضعیت</th>
              <th>جزئیات</th>
            </tr>
          </thead>
          <tbody class="still">
            <tr *ngFor="let item of cases">
              <td><bdi>#{{ item.iFraudMovementGroup | faNum }}</bdi></td>
              <td>
                <div class="fraud-vehicle-info">
                  <strong>{{ item.strFullName1 || '—' }}</strong>
                  <span class="muted">موبایل: <bdi dir="ltr">{{ item.strMobile1 || '—' | faNum }}</bdi></span>
                  <span class="muted">پلاک: <bdi>{{ item.strVehicleNo1 || '—' | faNum }}</bdi></span>
                </div>
              </td>
              <td>
                <div class="fraud-vehicle-info">
                  <strong>{{ item.strFullName2 || '—' }}</strong>
                  <span class="muted">موبایل: <bdi dir="ltr">{{ item.strMobile2 || '—' | faNum }}</bdi></span>
                  <span class="muted">پلاک: <bdi>{{ item.strVehicleNo2 || '—' | faNum }}</bdi></span>
                </div>
              </td>
              <td><bdi dir="ltr">{{ item.timeRange | faNum }}</bdi></td>
              <td>{{ (item.fFraudScore | number:'1.2-2') ?? '—' | faNum }}</td>
              <td>{{ item.iCommonMovementMinutes | number | faNum }} دقیقه</td>
              <td><span class="tag" [ngClass]="item.reviewClass">{{ item.reviewLabel }}</span></td>
              <td><a class="fraud-details-link" target="_blank" rel="noopener" routerLink="../case" [queryParams]="{ id: item.iFraudMovementGroup }">جزئیات</a></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div *ngIf="!loading && !error && cases.length" class="fraud-cases-footer">
      <p class="fraud-page-info muted">صفحه {{ page | faNum }} از {{ totalPages | faNum }} | {{ totalRecords | number | faNum }} پرونده</p>
      <app-table-pagination [page]="page" [pageSize]="pageSize" [totalItems]="totalRecords"
        [pageSizeOptions]="pageSizeOptions" (pageChange)="changePage($event)" (pageSizeChange)="changePageSize($event)">
      </app-table-pagination>
    </div>
  </section>
</div>
